import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Input shadcn adaptado ao React 18 (forwardRef, para o react-hook-form ler o valor) e aos tokens
 * do design: campo de 40px, borda #D4D4D8, foco com borda accent e halo de 3px (shadow-focus).
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(function Input(
  { className, type, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        'flex h-10 w-full min-w-0 rounded-md border border-input bg-card px-3 text-body text-ink',
        'transition-[color,box-shadow,border-color] outline-none placeholder:text-ink-disabled',
        'selection:bg-primary selection:text-primary-foreground file:border-0 file:bg-transparent',
        'focus-visible:border-primary focus-visible:shadow-focus',
        'aria-invalid:border-destructive aria-invalid:shadow-[0_0_0_3px_rgb(185_28_28/0.12)]',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
});

export { Input };
